import { UserTypes as Types } from "../types";

type DefaultState = {
  isFetching: boolean;
  isAuthenticated: boolean;
  token: null | string;
};
const defaultState: DefaultState = {
  isFetching: false,
  isAuthenticated: localStorage.getItem("token") ? true : false,
  token: localStorage.getItem("token"),
};

function userReducer(state = defaultState, action: any) {
  switch (action.type) {
    case Types.LOGIN_REQUEST:
      return Object.assign({}, state, { isFetching: true });
    case Types.LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        isAuthenticated: true,
        token: action.payload.result.token,
      });
    case Types.LOGIN_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
      });
    case Types.LOGOUT_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case Types.LOGOUT_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        isAuthenticated: false,
        token: null,
      });
    case Types.LOGOUT_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
      });
    default:
      return state;
  }
}

export default userReducer;
